import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "./config.service";
import {Router} from '@angular/router';
import { CONSTANT } from '../config/constant';

@Injectable()
export class LoginServiceService {
  logo: string;

  // public authToken: Subject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient, public configService: ConfigService, public router: Router) { }

  //
  // verifyUserDetails(userDetails) {
  //   return this.http.post(this.configService.appConfig.loginBaseURL + '/authentication/login', userDetails);
  // }
  //
  // roleMatch(allowedRoles) {
  //   let isMatch: boolean;
  //   isMatch = false;
  //   let userRoles: string[];
  //   userRoles = JSON.parse(sessionStorage.getItem('userRoles'));
  //   allowedRoles.forEach(element => {
  //     if (userRoles.indexOf(element) > -1) {
  //        isMatch = true;
  //        return false;
  //     }
  //   });
  //   return isMatch;
  // }
  //
  // updateLogoToSideMenu(logo) {
  //   this.logo = logo;
  // }
  //
  // getAndSendToken(tokenFromLogin?) {
  //   if (tokenFromLogin) {
  //     this.authToken.next(tokenFromLogin);
  //   } else {
  //     this.authToken.next(null);
  //   }
  // }

  getLogo() {
    return this.http.get(`${this.configService.appConfig.appBaseUrl}account/self/logo`);
  }

  getKioskSubQrCode(){
    return this.http.get(`${this.configService.appConfig.appBaseUrl}sokSubscription/qrCodePayment`)
  }


  storeAssetTypes(assetTypes: Array<unknown>) {
    sessionStorage.setItem(CONSTANT.ASSET_SESSION_KEY, JSON.stringify(assetTypes));
  }

}
